module.exports = __webpack_public_path__ + "front/img/d4.6f49e38c.png";